import { IGeoStep } from '../types';
import { EGeoTypes } from '../constants/geoTypes';
import { EStepField } from '../constants/stepField';

const REASONS_MAP = {
  buy: 'купить',
  sell: 'продать',
  tenant: 'снять',
  rent: 'сдать',
  sellToBuy: 'продать, чтобы купить',
};
export type TReason = keyof typeof REASONS_MAP;

const OBJECT_TYPE_MAP = {
  flat: 'квартиру',
  room: 'комнату',
  house: 'дома или дачу',
  cottage: 'коттедж',
  townhouse: 'таунхаус',
  houseShare: 'часть дома',
  land: 'участок',
  office: 'офис',
  shoppingArea: 'торговую площадку',
  freeAppointmentObject: 'помещение свободного назначения',
  industry: 'производство',
  warehouse: 'склад',
  garage: 'гараж',
  business: 'готовый бизнес',
  commercialLand: 'коммерческую землю',
};
export type TObjectType = keyof typeof OBJECT_TYPE_MAP;

export const getLocationStep = (reason: TReason, objectType: TObjectType): IGeoStep => {
  const reasonText = REASONS_MAP[reason];
  const objectText = OBJECT_TYPE_MAP[objectType];

  const title =
    reasonText && objectText
      ? `В каком городе или регионе вы хотите ${reasonText} ${objectText}?`
      : 'Укажите город или регион';

  return {
    title,
    isRequired: true,
    field: EStepField.location,
    types: [EGeoTypes.region],
    placeholder: 'Название города или региона',
  };
};
